// src/opencomponents/LoginUser.js — V18 login over the flesh corridor.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { authApiClient } from '../api/apiClient';
import AuthStage from '../components/AuthStage';
import { Field, Input, PrimaryButton, ErrorText, TextLink } from '../components/ui';
import { color } from '../theme/tokens';

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 22px;
`;

const Foot = styled.p`
    margin: 0;
    text-align: center;
    font-size: 14px;
    color: ${color.text3};
`;

function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await authApiClient.post('/auth/login-general', { username, password });
            
            if (response.data && response.data.user) {
                onLogin(response.data.user);
                navigate('/'); 
            }

        } catch (err) {
            const message = err.response?.data?.message || '用户名或密码错误。';
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthStage title="登入" quote="だって、ここが、すでに、奈落。">
            {(eye) => (
                <Form onSubmit={handleSubmit}>
                    <Field>
                        <label htmlFor="login-username">用户名</label>
                        <Input
                            id="login-username"
                            type="text"
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onFocus={eye.focusName}
                            onBlur={eye.blur}
                            required
                            disabled={loading}
                        />
                    </Field>
                    <Field>
                        <label htmlFor="login-password">密码</label>
                        <Input
                            id="login-password"
                            type="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onFocus={eye.focusSecret}
                            onBlur={eye.blur}
                            required
                            disabled={loading}
                            $invalid={!!error}
                            aria-describedby="login-error"
                        />
                    </Field>
                    <ErrorText id="login-error" role="alert">{error}</ErrorText>
                    <PrimaryButton type="submit" disabled={loading} $block>
                        {loading ? '登录中…' : '登 录'}
                    </PrimaryButton>
                    <Foot>还没有账号？<TextLink to="/register">注册</TextLink></Foot>
                </Form>
            )}
        </AuthStage>
    );
}

export default Login;
